import { render, staticRenderFns } from "./FormResultPunish.vue?vue&type=template&id=adb25426"
import script from "./FormResultPunish.vue?vue&type=script&lang=ts"
export * from "./FormResultPunish.vue?vue&type=script&lang=ts"
import style0 from "./FormResultPunish.vue?vue&type=style&index=0&id=adb25426&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports